// Compound Interest Calculator Tool — lump-sum growth over time.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const compoundInterestTool: Tool = {
  id: "compound-interest",
  name: () => m.cp_tool_name(),
  description: () => m.cp_tool_description(),
  icon: "📈",
  basePath: "/compound-interest",
  status: "stable",
  tags: ["compound", "interest", "savings", "finance"],
  pages: [
    {
      name: () => m.cp_nav_main(),
      path: "/compound-interest",
      description: () => m.cp_nav_main_desc(),
      icon: "📈",
    },
  ],
};
